import { render, staticRenderFns } from "./FloatingWhatsappButton.vue?vue&type=template&id=e85f9894&"
import script from "./FloatingWhatsappButton.vue?vue&type=script&lang=js&"
export * from "./FloatingWhatsappButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingWhatsappButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports